module.exports = __webpack_public_path__ + "img/quizcate.aa849507.png";